export enum PopupIcons{
    Info = "info",
    Warn = "warning",
    Error = "error"
}